
// Product Acccordian
const items = document.querySelectorAll(".product-accordion-item");

items.forEach(item => {

const header = item.querySelector(".product-accordion-header");
const content = item.querySelector(".product-accordion-content");

if(item.classList.contains("active")){
content.style.height = content.scrollHeight + "px";
}

header.addEventListener("click", () => {

items.forEach(i => {

const c = i.querySelector(".product-accordion-content");

if(i !== item){
i.classList.remove("active");
c.style.height = 0;
}

});

if(item.classList.contains("active")){
item.classList.remove("active");
content.style.height = 0;
}else{
item.classList.add("active");
content.style.height = content.scrollHeight + "px";
}
});


});


// Review Slide
jQuery(document).ready(function ($) {
  setTimeout(function () {
    $('.jdgm-review-list').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            dots: true,
          arrows: false
          }
        }
      ]
    });
    $( ".jm-review-widget-minimal-header__action-buttons" ).insertAfter( $( ".jm-review-widget__body" ) );
  }, 1000);
});

// change text
document.addEventListener("DOMContentLoaded", function() {

setTimeout(function(){

let btn = document.querySelector('#more-payment-options-link');

if(btn){
btn.textContent = "Buy Now";
}

},500);

});